<template>

    <ListDetailsLayout v-bind:active="details_activated" v-on:close_panel="unselect()" >
        <template slot="list">
            <v-card >
                <v-app-bar>
                    <v-toolbar-title>Human Resources Management</v-toolbar-title>
                    <v-spacer></v-spacer>

                    <v-btn-toggle
                            mandatory
                            v-model="list_view_mode"
                    >
                        <v-btn value="table" >
                            <v-icon>mdi-table</v-icon>
                        </v-btn>
                        <v-btn value="cards" >
                            <v-icon>mdi-checkbook</v-icon>
                        </v-btn>
                    </v-btn-toggle>
                    <v-btn-toggle>
                        <v-btn v-model="details_activated" @click="details_activated= !details_activated" >
                            <v-icon v-if="!details_activated">mdi-arrow-expand-right</v-icon>
                            <v-icon v-else >mdi-arrow-expand-left</v-icon>
                        </v-btn>
                    </v-btn-toggle>



                </v-app-bar>

                <v-card-text >

                    <!-- Here table of members -->
                    <template v-if="list_view_mode==='table'">
                        <v-card>
                            <v-card-title>
                                <v-text-field
                                        v-model="search"
                                        append-icon="mdi-magnify"
                                        label="Search"
                                        single-line
                                        hide-details
                                ></v-text-field>
                            </v-card-title>
                            <v-data-table
                                    :items="items"
                                    :headers="headers"
                                    :search="search"
                                    @click:row="select_member"
                            >
                                <template v-slot:top>
                                    <v-toolbar flat color="white">
                                        <v-toolbar-title>Members</v-toolbar-title>
                                        <v-divider
                                                class="mx-4"
                                                inset
                                                vertical
                                        ></v-divider>
                                        <v-spacer></v-spacer>
                                        <CreateMemberDialog @change="addMember"></CreateMemberDialog>
                                    </v-toolbar>
                                </template>
                            </v-data-table>
                        </v-card>
                    </template>

                    <template v-else>
                        <v-item-group active-class="primary">
                            <v-container>
                                <v-row>
                                    <v-col
                                            v-for="member in items"
                                            :key="member.member_id"
                                            cols="12"
                                            md="6"
                                    >
                                        <v-item v-slot:default="{ active }">
                                            <!--
                                            <v-card
                                                    class="d-flex align-center"
                                                    dark
                                                    height="200"
                                                    @click="toggle"
                                            >
                                                <v-scroll-y-transition>
                                                    <div
                                                            v-if="active"
                                                            class="display-3 flex-grow-1 text-center"
                                                    >
                                                        Active
                                                    </div>
                                                </v-scroll-y-transition>
                                            </v-card>-->
                                            <MemberCard @select="select_member(member)" v-bind:active="active" v-bind:member="member"></MemberCard>
                                        </v-item>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-item-group>
                    </template>

               </v-card-text>

            </v-card>

            <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
                {{ snackText }}

                <template v-slot:action="{ attrs }">
                    <v-btn
                            color="red"
                            text
                            v-bind="attrs"
                            @click="snack = false"
                    >
                        Close
                    </v-btn>
                </template>
            </v-snackbar>

        </template>

        <template slot="details_laptop">
            <v-scroll-y-transition mode="out-in">
                <div
                        v-if="!selected_document"
                        class="title grey--text text--lighten-1 font-weight-light"
                        style="align-self: center;"
                >
                    Select a Document

                </div>
                <v-card
                        v-else
                        :key="selected_document.member_id"
                        flat
                        v-scroll
                >
                    <v-list-item>
                        <v-list-item-avatar color="grey"></v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title class="headline">Details on #{{ selected_document.member_id }}</v-list-item-title>
                            <v-list-item-subtitle>
                                <h3 class="subtitle-1 mb-2">
                                    <v-icon v-if="selected_document.gender==='F'">mdi-gender-female</v-icon>
                                    <v-icon v-else-if="selected_document.gender==='M'">mdi-gender-male</v-icon>
                                    {{ selected_document.first_name }} {{ selected_document.surname  }}
                                </h3>
                                <div class="blue--text mb-2"><a :href="'mailto:'+selected_document.email">{{ selected_document.email }}</a></div>
                                <div v-if="selected_document.account" class="blue--text mb-1">Account: {{ selected_document.account.user.username }}</div>

                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>

                    <v-card-title></v-card-title>
                    <v-card-text>


                    </v-card-text>
                    <v-divider></v-divider>
                    <v-row
                            class="text-left"
                            tag="v-card-text"
                            v-if="selected_document.birth_date"
                    >

                        <v-col class="text-right mr-4 mb-2" tag="strong" cols="5"><v-icon>mdi-cake-variant</v-icon></v-col>
                        <v-col>{{ selected_document.birth_date }} - {{ selected_document.age }}</v-col>
                    </v-row>
                    <v-row
                            class="text-left"
                            tag="v-card-text"
                    >
                        <v-col class="text-right mr-4 mb-2" tag="strong" cols="5"><v-icon>mdi-phone</v-icon></v-col>
                        <v-col><a :href="'tel:'+selected_document.phone_number">{{ selected_document.phone_number }}</a></v-col>

                    </v-row>
                    <v-divider></v-divider>
                    <v-row
                        class="text-left"
                        tag="v-card-text"
                        v-if="selected_document.address"
                    >
                        <v-col class="text-right mr-4 mb-2" tag="strong" cols="5">Country</v-col>
                        <v-col>{{ selected_document.address.country }}</v-col>
                        <v-col class="text-right mr-4 mb-2" tag="strong" cols="5">Address</v-col>
                        <v-col>
                            <ul>{{ selected_document.address.address }}</ul>
                            <ul>{{ selected_document.address.zipCode }} - {{ selected_document.address.city }}</ul>

                        </v-col>
                    </v-row>
                    <VcardComponent :contact="selected_document"></VcardComponent>
                    <v-btn class="red white--text" @click="deleteMember">delete</v-btn>

                </v-card>
            </v-scroll-y-transition>
        </template>

        <template slot="details_phone">
            <div
                    v-if="!selected_document"
                    class="title grey--text text--lighten-1 font-weight-light"
                    style="align-self: center;"
            >
                Select a Document

            </div>
            <v-card
                    v-else
                    :key="selected_document.member_id"
                    flat

            >
                <v-card-title>Details on #{{ selected_document.member_id }}</v-card-title>
                <v-card-text >
                    <v-avatar
                            v-if="selected_document.avatar"
                    >
                        <v-img
                                :src="`https://avataaars.io/${selected_document.avatar}`"
                                class="mb-6"
                        ></v-img>
                    </v-avatar>
                    <h3 class="headline mb-2">
                        <v-icon v-if="selected_document.gender==='F'">mdi-gender-female</v-icon>
                        <v-icon v-else-if="selected_document.gender==='M'">mdi-gender-male</v-icon>
                        {{ selected_document.first_name }} {{ selected_document.surname  }}
                    </h3>
                    <div class="blue--text mb-2"><a :href="'mailto:'+selected_document.email">{{ selected_document.email }}</a></div>
                    <div v-if="selected_document.account" class="blue--text mb-1">Account: {{ selected_document.account.user.username }}</div>



                    <v-divider></v-divider>
                    <v-row
                            class="text-left"
                            tag="v-card-text"
                            v-if="selected_document.birth_date"
                    >

                        <v-col class="text-right mr-4 mb-2" tag="strong" cols="5"><v-icon>mdi-cake-variant</v-icon></v-col>
                        <v-col>{{ selected_document.birth_date }} - {{ selected_document.age }}</v-col>
                    </v-row>
                    <v-row
                            class="text-left"
                            tag="v-card-text"
                    >
                        <v-col class="text-right mr-4 mb-2" tag="strong" cols="5"><v-icon>mdi-phone</v-icon></v-col>
                        <v-col><a :href="'tel:'+selected_document.phone_number">{{ selected_document.phone_number }}</a></v-col>

                    </v-row>
                    <v-divider></v-divider>
                    <v-row
                            class="text-left"
                            tag="v-card-text"
                            v-if="selected_document.address"
                    >
                        <v-col class="text-right mr-4 mb-2" tag="strong" cols="5">Country</v-col>
                        <v-col>{{ selected_document.address.country }}</v-col>
                        <v-col class="text-right mr-4 mb-2" tag="strong" cols="5">Address</v-col>
                        <v-col>
                            <ul>{{ selected_document.address.address }}</ul>
                            <ul>{{ selected_document.address.zipCode }} - {{ selected_document.address.city }}</ul>

                        </v-col>
                    </v-row>
                    <VcardComponent :contact="selected_document"></VcardComponent>
                    <v-btn class="red white--text" @click="deleteMember">delete</v-btn>
                </v-card-text>


            </v-card>
        </template>


    </ListDetailsLayout>






</template>

<script>
import RhService from '../../../services/apps/rh.service'
import CreateMemberDialog from "../documents/CreateMember";
import VcardComponent from "../../templates/block/VcardComponent";
import ListDetailsLayout from "../../templates/layouts/ListDetailsLayout";
import MemberCard from "../../templates/block/MemberCard";
    export default {
        name: 'HRIndexPage',
        components: {MemberCard, VcardComponent, CreateMemberDialog,ListDetailsLayout},
        data() {
            return {
                search: null,
                headers: [
                    {
                        text: 'Id',
                        align: 'start',
                        filterable: false,
                        value: 'member_id',
                    },
                    { text: 'Name', value: 'first_name' },
                    { text: 'Surname', value: 'surname' },
                    { text: 'Birth', value: 'birth_date' },
                    { text: 'Account', value: 'account.user.username' },
                ],
                items: [
                    { title: 'Dashboard', icon: 'mdi-monitor-dashboard' },
                    { title: 'RH', icon: 'mdi-account-group-outline' },
                    { title: 'Documents', icon: 'mdi-file-multiple' },
                    { title: 'Taches', icon: 'mdi-calendar-check' },
                    { divider: true, inset: false },
                    { title: 'Mon compte', icon: 'mdi-account' },
                ],
                mini: true,
                selected: 1,
                selected_document: null,


                snack: true,
                snackColor: 'info',
                snackText: 'Hello',

                list_view_mode: 'cards',
                details_activated: false


            }
        },
        mounted() {
            RhService.getMemberList().then(res=> this.items = res.data)
        },
        methods:{
            addMember(member){
                this.items.push(member);
            },
            deleteMember(){
                let id_member = this.selected_document.member_id;
                console.log(id_member);
                RhService.deleteMember(id_member)
                    .then(res=>{
                        if(res.status === 200){
                            this.openSnack('Member deleted','info')
                        }else{
                            this.openSnack(`Error: ${res.status} - ${res.statusText}`,'warning')
                        }

                    })

                this.items = this.items.filter(e=>{return e.member_id!==id_member});
                this.unselect()
            },
            select_member(e){
                this.openSnack('selected');
                const memory = window.navigator.deviceMemory;
                console.log (`This device has at least ${memory} GiB of RAM.`)
                window.navigator.vibrate([100,30,100,30,100,30,200,30,200,30,200,30,100,30,100,30,100]);

                this.selected_document = e;
                this.details_activated = true;

            },
            unselect(){
                this.selected_document = null;
                this.details_activated = false;

            },
            openSnack(text='Hello',color='info'){
                this.snack = true;
                this.snackColor = color;
                this.snackText = text
            }
        },
        computed: {
            /*
            selected_document () {
                if (this.selected<0) return undefined

                const pos = this.selected;



                return this.items[pos]
            },*/
        }
    }

</script>
<style >
    .my-v-card {
        align-items: stretch;

    }




</style>
